export default __webpack_public_path__ + "static/media/Flag_of_Uganda.7c84fe9a.svg";